import { Text } from "@/components/ui/text";
import { ratings } from "@/constants/ratings";
import { cn } from "@/lib/utils";
import { Pressable, View } from "react-native";

const RATINGS = [
  {"height": "17%", "bg-color": "bg-muted-foreground/25", "text-color": "text-muted-foreground/25"},
  {"height": "33%", "bg-color": "bg-muted-foreground", "text-color": "text-muted-foreground"},
  {"height": "67%", "bg-color": "bg-primary", "text-color": "text-primary"},
  {"height": "100%", "bg-color": "bg-mustTry", "text-color": "text-mustTry"},
];

interface RatingProps {
  rating: number;
  onPress?: () => void;
}

export function Rating({ rating, onPress }: RatingProps) {

  const label = ratings[rating as keyof typeof ratings];

  const content = (
    <View className="items-center">
      <View className="flex-row items-end h-6">
        {RATINGS.slice(0, rating + 1).map((aRating, index) => (
          <View key={index} className={cn(
            'w-1.5 mx-0.5',
            `${RATINGS[rating]["bg-color"]}`,
          )}
          style={{ height: aRating.height as any }} />
        ))}
          {RATINGS.slice(rating + 1, RATINGS.length).map((aRating, index) => (
          <View key={index} className={cn(
            'w-1.5 mx-0.5 bg-secondary',
          )}
          style={{ height: aRating.height as any }} />
        ))}
      </View>

      <Text className={cn(
        'text-xs font-bold mt-0.5 uppercase',
        `${RATINGS[rating]["text-color"]}`,
      )}>
        {label}
      </Text>

    </View>
  );

  if (onPress) {
    return (
      <Pressable onPress={onPress}>
        {content}
      </Pressable>
    );
  }

  return content;
}

export default Rating;
